export const monthlyCostConfig = {
	columnName: 'Actual Monthly Cost',
	valueSuffix: '/mo',
};
